import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { getIntentLink } from '../intents/intentSelectors';
import { getSalesExtensionRedirect } from '../intents/SalesExtensionUtils';
import { useLoginRedirect } from '../signup-completed-redirection/useLoginRedirect';
import { useTracker } from '../tracking/useTracker';
import { Step } from 'signup-constants/Step';
import { useSelector } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CheckYourEmailGoToLoginButton = ({
  email
}) => {
  const tracker = useTracker();
  const intentLink = useSelector(getIntentLink);
  const {
    redirectToLogin
  } = useLoginRedirect();
  const redirectUrl = useSelector(state => getSalesExtensionRedirect(state, intentLink || ''));
  if (!email) {
    return null;
  }
  const handleGoToLogin = () => {
    tracker.signupInteraction('check-you-email-go-to-login');
    redirectToLogin({
      redirectUrl,
      email
    });
  };
  return /*#__PURE__*/_jsxs(UIButton, {
    size: "sm",
    use: "primary",
    onClick: handleGoToLogin,
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "locked"
    }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `views.${Step.Verification}.salesExtension.goToLoginOnceDone`
    })]
  });
};
export default CheckYourEmailGoToLoginButton;